export default "__VITE_ASSET__ba7914f4__"